import { useState, useEffect } from 'react';

interface FearGreedData {
  value: string;
  value_classification: string;
}

const PT_LABELS: Record<string, string> = {
  'Extreme Fear': 'Medo Extremo',
  'Fear': 'Medo',
  'Neutral': 'Neutro',
  'Greed': 'Ganancia',
  'Extreme Greed': 'Ganancia Extrema',
};

function getColor(value: number) {
  if (value <= 25) return { text: 'text-red-600', bg: 'bg-red-50', border: 'border-red-200' };
  if (value <= 45) return { text: 'text-orange-500', bg: 'bg-orange-50', border: 'border-orange-200' };
  if (value <= 55) return { text: 'text-yellow-600', bg: 'bg-yellow-50', border: 'border-yellow-200' };
  if (value <= 75) return { text: 'text-lime-600', bg: 'bg-lime-50', border: 'border-lime-200' };
  return { text: 'text-green-600', bg: 'bg-green-50', border: 'border-green-200' };
}

export const FearGreedWidget: React.FC = () => {
  const [data, setData] = useState<FearGreedData | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch('https://api.alternative.me/fng/?limit=1');
        const json = await res.json();
        setData(json.data[0]);
      } catch {
        // silent
      }
    };
    load();
  }, []);

  if (!data) return null;

  const value = parseInt(data.value);
  const colors = getColor(value);
  const label = PT_LABELS[data.value_classification] || data.value_classification;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-bold mb-3">Indice Medo &amp; Ganancia</h3>
      <div className={`rounded-xl border ${colors.bg} ${colors.border} py-4 px-6 flex flex-col items-center`}>
        <span className={`text-5xl font-black ${colors.text}`}>{value}</span>
        <span className={`text-sm font-semibold mt-1 ${colors.text}`}>{label}</span>
      </div>
      <div className="mt-3">
        <div className="relative h-2.5 rounded-full overflow-hidden bg-gradient-to-r from-red-500 via-yellow-400 to-green-500">
          <div
            className="absolute top-0 h-2.5 w-2 bg-white shadow rounded-full border border-gray-300"
            style={{ left: `calc(${value}% - 4px)` }}
          />
        </div>
        <div className="flex justify-between text-xs text-gray-400 mt-1">
          <span>Medo</span>
          <span>Ganancia</span>
        </div>
      </div>
      <p className="text-xs text-gray-400 mt-3 text-center">Fonte: alternative.me</p>
    </div>
  );
};
